import { twMerge } from "tailwind-merge";

export default function Divider({ className }: { className?: string }) {
  return <hr className={twMerge("border-neutral-600 border-2 rounded-full flex-1 block", className)}></hr>;
}
